import { gql } from "@apollo/client";
import { Organization } from "@App/types";

export interface OrganizationNetworkQuery {
  organization: Organization;
}

export const GET_ORGANIZATION_NETWORK = gql`
    query getOrganizationNetwork($organization:ID!, $services: [ID], $driver: UUID, $presetFilters: [PresetFilter], $brand: ID) {
        organization(id: $organization) {
            id
            network(services: $services, driver: $driver, presetFilters: $presetFilters, brand: $brand) {
                id
                name
            }
        }
    }
`;
